// Converts rich-text HTML (from the admin editor) to plain text, decoding
// entities such as &nbsp; and &amp; so they don't show up literally.
export const stripHtml = (html) => {
  if (!html) return '';
  let text;
  if (typeof DOMParser !== 'undefined') {
    const withBreaks = html.replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi, '$& ');
    text = new DOMParser().parseFromString(withBreaks, 'text/html').body.textContent || '';
  } else {
    text = html
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }
  return text.replace(/[\s ]+/g, ' ').trim();
};

export const truncateText = (text, length) =>
  text.length > length ? text.substring(0, length).trimEnd() + '...' : text;

// Rich text saved by the admin editor can contain &nbsp; for every space,
// which stops text from wrapping. Swap them for normal spaces before rendering.
export const normalizeRichText = (html) =>
  html ? html.replace(/&nbsp;|\u00a0/g, ' ') : '';
